import { Pipe, PipeTransform } from '@angular/core';
import { DateTimeService, FormatoFecha, UnidadTiempoDateFns } from '../../utils/datetime.service';

@Pipe({
  name: 'formatDate'
})
export class FormatDatePipe implements PipeTransform {

  constructor(private dateTimeService: DateTimeService) {
  }

  transform(value: any, format: FormatoFecha): any {
    let fechaBase;
    if (this.dateTimeService.esFechaISO(value)) {
      fechaBase = this.dateTimeService.parseISO(value)
    }

    if (!this.dateTimeService.esFechaValida(fechaBase))
      return value;
    
    fechaBase = this.dateTimeService
                    .agregarUnidad(1, UnidadTiempoDateFns.Days, false, fechaBase);
    
    return DateTimeService.formatearFecha(fechaBase, format);
  }
}

